import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AppContext from "../../../context/AppContext";
import MyLayout from "../../../layouts/customer/MyLayout";
// import "../../../assets/styles/customer/layout/login.css"

const Login = () => { 
    const [username, setUsername] = useState();
    const [password, setPassword] = useState();
    const [isScreenLoading, setIsScreenLoading] = useState(true);
    const navigation = useNavigate();
      const { baseUrl } = useContext(AppContext);



    ////////////////////////////////////////
    /////////////   FUNCTIONS //////////////
    ////////////////////////////////////////

    const userLogin = (pUSERNAME, pPASSWORD, customerId) => {

        console.log(pUSERNAME);
        console.log(pPASSWORD);
        console.log(customerId)


        let credentials = {
            "username": pUSERNAME,
            "password": pPASSWORD,
            "customerId" : customerId
        };
        axios.post(`${baseUrl}/auth/login`, credentials)
            .then(response => {
                console.log(response.data)
                localStorage.setItem("username", pUSERNAME);
                localStorage.setItem("password", pPASSWORD);
                localStorage.setItem("customerId", customerId);
                navigation("/fakeApi");
            }
            ).catch((error) => { console.error(error) });
    }

    const checkAvailableUser = () => {
        let savedUsername = localStorage.getItem("username");
        let savedPassword = localStorage.getItem("password");
        // let savedCustomerId = localStorage.setItem("customerId");

        if (savedUsername != null && savedPassword != null) {
            userLogin(savedUsername, savedPassword);
        } else {
            setIsScreenLoading(false);
            console.log("Please perform login");
        }
    }

    useEffect(() => {
        checkAvailableUser();
    }, [])
    return (
        <MyLayout>
        isScreenLoading ? <div style={{height:"100vh"}} className="d-flex justify-content-center align-items-center">
            <Spinner size="lg" color="black" />
        </div> :
            <Form className="p-5">
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label>User Name</Form.Label>
                    <Form.Control onChange={(event) => { setUsername(event.target.value) }} type="text" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Password</Form.Label>
                    <Form.Control onChange={(event) => { setPassword(event.target.value) }} type="password" />
                </Form.Group>
                <Button onClick={() => { userLogin(username, password) }} className="btn btn-primary">LOGIN</Button>
            </Form>
        </MyLayout>
    );
}

export default Login;